import { Workbox } from "workbox-window"

const UPDATE_CHECK_INTERVAL_MS = 60_000

// Only register service worker in production - vite-plugin-pwa does not
// generate sw.js in dev mode, so requesting it returns index.html
// which causes "unsupported MIME type" errors in the browser console.
const wb = (!import.meta.env.DEV && "serviceWorker" in navigator)
  ? (() => {
      const workbox = new Workbox(`${import.meta.env.BASE_URL || "/"}sw.js`)
      workbox.addEventListener("controlling", (event) => {
        if (event.isUpdate)
          window.location.reload()
      })
      workbox.register().then((registration) => {
        if (registration)
          setInterval(() => registration.update(), UPDATE_CHECK_INTERVAL_MS)
      })
      return workbox
    })()
  : null

export default wb
